export const PRINT_TYPE ={
    DOT_MATRIX : 0,
    POS:1
}